import script from "./SalaryChange.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryChange.vue?vue&type=script&setup=true&lang=js"

import "./SalaryChange.vue?vue&type=style&index=0&id=54e343b0&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e343b0"]])

export default __exports__